// extracted by mini-css-extract-plugin
export default {"cell":"ShowInvestor_cell__ZlYBl"};